import React, { useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faTimesCircle } from '@fortawesome/pro-solid-svg-icons'

import { FormErrorMessage } from 'components/reusables/formErrorMessage'
import { useTranslationRankmi } from 'helpers/translations.helper'
import {
  FileName,
  HiddenInput,
  Hint,
  Label,
  Labels,
  RemoveFileButton,
  Row,
  SelectedFile,
  UploadLink,
} from './styled'

interface CourseImageFileInputProps {
  name: string
  label: string
  hint: string
  value?: { name?: string }
  error?: string
  disabled?: boolean
  onChange: (file: File | '') => void
}

export const CourseImageFileInput: React.FC<CourseImageFileInputProps> = ({
  name,
  label,
  hint,
  value,
  error = '',
  disabled = false,
  onChange,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const t = useTranslationRankmi({
    prefix: 'administration.courses.new.form.images',
  })

  const handleSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      onChange(file)
    }
  }

  const handleUploadClick = () => {
    if (inputRef.current) {
      inputRef.current.value = ''
      inputRef.current.click()
    }
  }

  return (
    <div>
      <Row>
        <Labels>
          <Label>{label}</Label>
          <Hint>{hint}</Hint>
          {value?.name ? (
            <SelectedFile>
              <FileName title={value.name}>{value.name}</FileName>
              <RemoveFileButton
                type="button"
                disabled={disabled}
                onClick={() => onChange('')}
                aria-label={t('removeFile')}
              >
                <FontAwesomeIcon icon={faTimesCircle} />
              </RemoveFileButton>
            </SelectedFile>
          ) : null}
        </Labels>
        <UploadLink
          type="button"
          disabled={disabled}
          onClick={handleUploadClick}
        >
          <FontAwesomeIcon icon={faUpload} aria-hidden />
          {t('upload')}
        </UploadLink>
        <HiddenInput
          ref={inputRef}
          id={`course-image-file-${name}`}
          name={name}
          type="file"
          accept="image/png, image/jpeg"
          disabled={disabled}
          onChange={handleSelectFile}
        />
      </Row>
      {error ? <FormErrorMessage message={error} /> : null}
    </div>
  )
}
